/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateSavingsBalanceRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {CreateSavingsBalanceResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const createSavingsBalance = (request: CreateSavingsBalanceRequest, options?: CashRequestOptions) => post<CreateSavingsBalanceRequest, CreateSavingsBalanceResponse>("/2.0/cash/create-savings-balance", request, {...options, rejectOnError: true })